import React from 'react';
import { PillIcon, FactoryIcon, FlameIcon, AlertTriangleIcon } from 'lucide-react';
export function DamageFactors() {
  const factors = [{
    icon: <PillIcon className="w-10 h-10 sm:w-12 sm:h-12" data-id="element-154" />,
    emoji: '💊',
    title: 'Conserveringsmiddelen in commercieel voer',
    description: 'Doden bacteriën... zowel de slechte als de goede'
  }, {
    icon: <FlameIcon className="w-10 h-10 sm:w-12 sm:h-12" data-id="element-155" />,
    emoji: '🔥',
    title: 'Kleurstoffen, smaakversterkers en kunstmatige toevoegingen',
    description: 'Belasten het spijsverteringsstelsel'
  }, {
    icon: <PillIcon className="w-10 h-10 sm:w-12 sm:h-12" data-id="element-156" />,
    emoji: '💊',
    title: 'Antibiotica en ontwormingsmiddelen',
    description: 'Vernietigen de complete darmflora'
  }, {
    icon: <AlertTriangleIcon className="w-10 h-10 sm:w-12 sm:h-12" data-id="element-157" />,
    emoji: '⚠️',
    title: 'Stress, medicatie en verkeerde voeding',
    description: 'Brengen het ecosysteem uit balans'
  }];
  return <section className="py-12 sm:py-16 lg:py-20 bg-gradient-to-b from-white to-red-50" data-id="element-158">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-159">
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-center text-[rgb(var(--color-neutral-900))] mb-8 sm:mb-12 lg:mb-16" data-id="element-160">
          Wat Beschadigt de Darmflora van uw Hond?
        </h2>

        <div className="space-y-5 sm:space-y-6 mb-8 sm:mb-12" data-id="element-161">
          {factors.map((factor, index) => <div key={index} className="damage-factor-card" data-id="element-162">
              <div className="damage-factor-icons" data-id="element-163">
                <span className="text-3xl sm:text-4xl" data-id="element-164">❌</span>
                <span className="text-3xl sm:text-4xl" data-id="element-165">{factor.emoji}</span>
              </div>
              <div className="damage-factor-content" data-id="element-166">
                <h3 className="damage-factor-title" data-id="element-167">{factor.title}</h3>
                <p className="damage-factor-description" data-id="element-168">
                  {factor.description}
                </p>
              </div>
            </div>)}
        </div>

        <div className="bg-gradient-to-r from-red-900 to-red-800 text-white p-6 sm:p-8 lg:p-12 rounded-2xl shadow-2xl" data-id="element-169">
          <div className="flex flex-col sm:flex-row items-start gap-4 sm:gap-6" data-id="element-170">
            <AlertTriangleIcon className="w-12 h-12 sm:w-16 sm:h-16 flex-shrink-0" data-id="element-171" />
            <div className="min-w-0 flex-1" data-id="element-172">
              <h3 className="text-xl sm:text-2xl font-bold mb-3 sm:mb-4" data-id="element-173">
                Het Gevolg
              </h3>
              <p className="text-base sm:text-lg leading-relaxed break-words" data-id="element-174">
                Een beschadigde darmflora die kan leiden tot een verzwakt
                immuunsysteem. En een verzwakt immuunsysteem betekent dat het
                lichaam constant in "noodmodus" staat. Het kan niet goed
                ontgiften, herstellen of zichzelf verdedigen.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}